import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class BlockFinalOnNewReferralGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    const isNew = localStorage.getItem('isNewReferral') === 'true';
    if (!isNew) return true;
    const code = (sessionStorage.getItem('securityCode') || localStorage.getItem('lastSecurityCode') || '').trim();
    if (code) return this.router.createUrlTree(['/', code]);
    return false;
  }
}
